import React, { createContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useAuthUsers from '../hooks/useAuthUsers';
import { firestore } from './FirebaseContext';

export const HostWalletContext = createContext({});

function HostWalletProvider({ children }) {
  const [hostWallet, setHostWallet] = useState({});
  const { currentUser } = useAuthUsers();
  const { actualRol } = useSelector((state) => state.dagpacketRoles);

  useEffect(() => {
    // console.log('se renderiza');
    async function getUserInfo() {
      await firestore
        .collection('wallets')
        .doc(currentUser.hostUser)
        .onSnapshot((snapshot) => {
          if (snapshot.exists) {
            setHostWallet(snapshot.data());
            // console.log(snapshot.data());
          }
        });
    }

    if (actualRol?.id === 'cajero' && currentUser?.hostUser) {
      getUserInfo();
    }
  }, [actualRol?.id, currentUser]);
  return <HostWalletContext.Provider value={{ hostWallet }}>{children}</HostWalletContext.Provider>;
}

export default HostWalletProvider;
